import React from 'react';
import map from 'lodash/map';
import partial from 'lodash/partial';
import {Dropdown} from 'semantic-ui-react';
import {bool, string, func} from 'prop-types';
import {SitesByLanguage} from 'utils/DBUtils';

const SiteMenu = props => {
  const options = map(SitesByLanguage, (site, lang) => (
    <Dropdown.Item
      key={lang}
      value={lang}
      onClick={partial(props.selectLang, lang)}
      content={<p className='filter-option' key={lang}>{site}</p>} />
  ));

  return (
    <Dropdown
      options={options}
      value={props.lang}
      disabled={props.disabled}
      text={SitesByLanguage[props.lang]}
      selection
      closeOnChange
      openOnFocus={false}
      selectOnBlur={false}
      selectOnNavigation={false}
      className='db-filter-dropdown' />
  );
};

SiteMenu.propTypes = {
  disabled: bool,
  lang: string.isRequired,
  selectLang: func.isRequired
};

export default SiteMenu;



// WEBPACK FOOTER //
// ./public/components/common/SiteMenu.jsx